import axios from 'axios'
import api_routes from '../../assets/js/api_routes';
import index from '../index'
var XLSX = require ('xlsx')

// Parameters
// head: needed information in JSON format for run the query in the API
// variables, station_sk, init_date, finish_date, page, per_page


const executeHidrometeorologicalQuery = async (head) =>{
                try {
                        const query_data = await axios.post( api_routes.get_hydrometeorological_data_by_station, head)
                        return query_data
                }catch (err) {
                        console.log("this is the error:" + err)
                }


}

const executeAirQualityQuery = async (head) =>{
        try {
                const query_data = await axios.post( api_routes.get_airQuality_data_by_station, head);
                return query_data
        }catch (err) {
                console.log("this is the error:" + err)
        }

}
const executeGroundWaterQuery = async (head) =>{
        try {
                const query_data = await axios.post( api_routes.get_groundWater_data_by_station, head);
                return query_data
        }catch (err) {
                console.log("this is the error:" + err)
        }

}
const dataActions= {
        async queryHidrometeorologicalData({commit }) {
                commit('change_state_loading')
                const head = {
                        variables: index.state.variablesSelected,
                        station_sk: index.state.station_id_selected,
                        init_date: index.state.initDate,
                        finish_date: index.state.endDate,
                        page: index.state.page,
                        per_page: index.state.perPage,
                        token: localStorage.access_token
                        }
                try {
                        const query_data = await axios.post( api_routes.get_hydrometeorological_data_by_station, head);
                        commit('change_totalPages', query_data.data.last_page)
                        commit('change_data', query_data.data.data)
                        commit('change_dataQuantity', query_data.data.total)
                        commit('change_state_loading')
                }catch (err) {
                        commit('change_state_loading')
                        console.log("this is the error:" + err)
                }
        },

        async queryAirQualityData({ commit }) {
                commit('change_state_loading')
                const head = {
                        variables: index.state.variablesSelected,
                        station_sk: index.state.station_id_selected,
                        init_date: index.state.initDate,
                        finish_date: index.state.endDate,
                        page: index.state.page,
                        per_page: index.state.perPage,
                        token: localStorage.access_token,
                        mode: index.state.mode
                        }
                try {
                        const query_data = await axios.post( api_routes.get_airQuality_data_by_station, head);
                        commit('change_totalPages', query_data.data.last_page)
                        commit('change_data', query_data.data.data)
                        commit('change_dataQuantity', query_data.data.total)
                        commit('change_state_loading')
                }catch (err) {
                        commit('change_state_loading')
                        console.log("this is the error:" + err)
                }
        },

        async queryGroundWaterData({ commit }) {
                commit('change_state_loading')
                const head = {
                        variables: index.state.variablesSelected,
                        station_sk: index.state.station_id_selected,
                        init_date: index.state.initDate,
                        finish_date: index.state.endDate,
                        page: index.state.page,
                        per_page: index.state.perPage,
                        token: localStorage.access_token
                        }
                try {
                        const query_data = await axios.post( api_routes.get_groundWater_data_by_station, head);
                        commit('change_totalPages', query_data.data.last_page)
                        commit('change_data', query_data.data.data)
                        commit('change_dataQuantity', query_data.data.total)
                        commit('change_state_loading')
                }catch (err) {
                        commit('change_state_loading')
                        console.log("this is the error:" + err)
                }
        },

        async downloadXlsxData() {
                const array_total_data = [];
                let typology_spanish = '';

                const head = {
                  variables: index.state.variablesSelected,
                  station_sk: index.state.station_id_selected,
                  init_date: index.state.initDate,
                  finish_date: index.state.endDate,
                  page: index.state.page,
                  per_page: index.state.dataQuantity,
                  station_name: index.state.station_name,
                  typology: index.state.typology,
                  token: localStorage.access_token
                };

                switch (head.typology) {
                  case 'hydrometeorological':
                    typology_spanish = "Climatológicos";
                    await executeQueryAndConcatData(executeHidrometeorologicalQuery);
                    break;
                  case 'airQuality':
                    typology_spanish = "Calidad del aire";
                    head.mode = index.state.mode;
                    await executeQueryAndConcatData(executeAirQualityQuery);
                    break;
                  case 'groundWater':
                    typology_spanish = "Aguas Subterráneas";
                    await executeQueryAndConcatData(executeGroundWaterQuery);
                    break;
                  case 'hydrological':
                    typology_spanish = "Hidrológicos";
                    await executeQueryAndConcatData(executeHidrometeorologicalQuery);
                    break;
                  default:
                    break;
                }
                async function executeQueryAndConcatData(queryFunction) {
                  const temp_data = await queryFunction(head);
                  array_total_data.push(...temp_data.data.data);

                  const total_data = temp_data.data.last_page;
                  if (total_data) {
                    for (let i = 2; i <= total_data; i++) {
                      head.page = i;
                      const temp_data = await queryFunction(head);
                      array_total_data.push(...temp_data.data.data);
                    }
                  }
                }

                let workbook = XLSX.utils.book_new()
                let worksheet = XLSX.utils.json_to_sheet(array_total_data,{raw: true})
                const filename = typology_spanish + '_' + head.station_name + '_'  + head.init_date + '_' + head.finish_date
                XLSX.utils.book_append_sheet(workbook, worksheet,"Datos")
                workbook["Sheets"]["Datos"]["!cols"] = new Array(10).fill({wpx:100})
                try{
                        XLSX.writeFile(workbook, `${filename}.xlsx`)
                }catch(err){
                        console.log(err, workbook)
                }
        }

}
export default dataActions
